// 需要把boolean类型的value 转为为 1、0的 字段
export const BOOLEAN_2_NUM_FIELDS = [
  'region_show',
  'genre_show',
  'company_show',
  'release_date_show',
  'ratio_show',
  'games_owned_show',
  'ipo_status_show',
  'headquaters_show',
  'game_type_show',
  'lang_region_show',
  'url_show',
  'steam_tag_show',
];
